var _dec, _class;

import { registerDecorator, ValidatorConstraint } from 'class-validator';
var IsDictConstraint = (_dec = ValidatorConstraint(), _dec(_class = class IsDictConstraint {
  validate(value, args) {
    if (typeof value !== 'object') return false;
    var type = args.constraints[0];
    if (typeof type === 'string') return Object.keys(value).every(k => typeof value[k] === type);
    return Object.keys(value).every(k => value[k] instanceof type);
  }

}) || _class);
export function IsDict(type, validationOptions) {
  return function (object, propertyName) {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [type],
      validator: IsDictConstraint
    });
  };
}